import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';
import AppDataTable from '../Components/AppDataTable';

export default class ShowcertificateTeacher extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modalallow: false,
            modaldisallow: false,
            id_citifacate: null,
            REASONS: null,
            behavior1: null,
            behavior2: null,
            behavior3: null,

            array_ShowReportPetition: [],
        }

        this.modalallow_open = this.modalallow_open.bind(this);
        this.modalallow_close = this.modalallow_close.bind(this);
        this.modaldisallow_open = this.modaldisallow_open.bind(this);
        this.modaldisallow_close = this.modaldisallow_close.bind(this);
        this.handleBehaviorChange = this.handleBehaviorChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.Update = this.Update.bind(this);
    }

    componentDidMount() {
        if (!(localStorage.getItem('token'))) {
            window.location.href = '/rubrongkpru'
        }
        axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/ShowReportCertificateTeacher/').then((ShowReportPetitionTeacher) => {
            if (ShowReportPetitionTeacher.data.length !== 0) {
                var i = 0;
                while (i < ShowReportPetitionTeacher.data.length) {
                    ShowReportPetitionTeacher.data[i]['Index'] = i + 1;
                    if (ShowReportPetitionTeacher.data[i]['STATUS'] === '5') {
                        ShowReportPetitionTeacher.data[i]['Statusfill'] = <span>
                            <button className="btn btn-success btn-sm" value={ShowReportPetitionTeacher.data[i].ID_NUMBER} onClick={this.modalallow_open}><MDBIcon icon="check-circle" /> อนุมัติ</button>
                            <button className="btn btn-danger btn-sm" value={ShowReportPetitionTeacher.data[i].ID_NUMBER} onClick={this.modaldisallow_open}><MDBIcon icon="ban" /> ไม่อนุมัติ</button></span>
                    }
                    i++;
                }
                this.setState({
                    array_ShowReportPetition: {
                        columns: [
                            { label: '#', field: 'Index', },
                            { label: 'วันที่ร้องขอ', field: 'DATE_INSERT', },
                            { label: 'รหัสนักศึกษา', field: 'OLDID', },
                            { label: 'ชื่อ-นามสกุล', field: 'NAME', },
                            { label: 'ขอใบรับรองเรื่อง', field: 'TYPEPITITION_NAME', },
                            { label: 'ภาษาไทย', field: 'NUM_RUBRONGTH', },
                            { label: 'ภาษาอังกฤษ', field: 'NUM_RUBRONGEN', },
                            { label: 'สถานะ', field: 'Statusfill', },
                        ],
                        rows: ShowReportPetitionTeacher.data
                    }
                })
            }
        })
    }

    handleBehaviorChange(event) {
        if (event.target.checked) {
            this.setState({ [event.target.name]: event.target.value })
        } else {
            this.setState({ [event.target.name]: null })
        }
    }

    modalallow_open(event) {
        this.setState({ modalallow: true });
        this.setState({ id_citifacate: event.target.value });
    }

    modalallow_close(event) {
        this.setState({ modalallow: false });
        this.setState({ id_citifacate: null });
        this.setState({ behavior1: null });
        this.setState({ behavior2: null });
        this.setState({ behavior3: null });
    }

    modaldisallow_open(event) {
        this.setState({ modaldisallow: true });
        this.setState({ id_citifacate: event.target.value });
    }

    modaldisallow_close(event) {
        this.setState({ modaldisallow: false });
        this.setState({ id_citifacate: null });
        this.setState({ REASONS: null });
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    Update(event) {
        event.preventDefault();
        var behavior = "";
        if (this.state.behavior1) {
            behavior += this.state.behavior1;
            if (this.state.behavior2) {
                behavior += "," + this.state.behavior2;
            }
            if (this.state.behavior3) {
                behavior += "," + this.state.behavior3;
            }
        } else {
            if (this.state.behavior2) {
                behavior += this.state.behavior2;
                if (this.state.behavior3) {
                    behavior += "," + this.state.behavior3;
                }
            } else {
                if (this.state.behavior3) {
                    behavior += this.state.behavior3;
                }
            }
        }
        let bodydata = {
            ID_NUMBER: this.state.id_citifacate,
            REASON_TEACHER: this.state.REASONS,
            BEHAVIOR: behavior,
            STATUS: event.target.value,
        }

        axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/UpdateStatusTeacher/' + this.state.id_citifacate, bodydata).then((data) => {
            if (data.data === 1) {

                this.setState({ modalallow: false });
                this.setState({ modaldisallow: false });
                this.setState({ id_citifacate: null });
                this.setState({ REASONS: null });
                this.setState({ behavior1: null });
                this.setState({ behavior2: null });
                this.setState({ behavior3: null });

                window.location.reload()
            }
        })
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>สถานะการขอใบรับรอง</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                สถานะการขอใบรับรอง
                            </MDBCardTitle>
                            <MDBCardText>
                                <AppDataTable data={this.state.array_ShowReportPetition} />
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBModal isOpen={this.state.modalallow} toggle={this.modalallow_close} centered>
                <MDBModalHeader toggle={this.modalallow_close}>รายละเอียดที่อนุมัติคำร้องขอ</MDBModalHeader>
                <MDBModalBody>

                    <label className="form-label">นักศึกษามีความประพฤติ ดังนี้</label><br />
                    <div className="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" className="custom-control-input" id="behavior1" name="behavior1" value="1" onChange={this.handleBehaviorChange} />
                        <label className="custom-control-label" for="behavior1">เรียนดี</label>
                    </div>

                    <div className="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" className="custom-control-input" id="behavior2" name="behavior2" value="2" onChange={this.handleBehaviorChange} />
                        <label className="custom-control-label" for="behavior2">ความประพฤติดี</label>
                    </div>

                    <div className="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" className="custom-control-input" id="behavior3" name="behavior3" value="3" onChange={this.handleBehaviorChange} />
                        <label className="custom-control-label" for="behavior3">เรียบร้อย</label>
                    </div>

                </MDBModalBody>
                <MDBModalFooter>
                    <button type="button" className="btn btn-primary btn-md" onClick={this.Update} value="1" >บันทึก</button>
                    <button type="button" className="btn btn-danger btn-md" onClick={this.modalallow_close}>ยกเลิก</button>
                </MDBModalFooter>
            </MDBModal>

            <MDBModal isOpen={this.state.modaldisallow} toggle={this.modaldisallow_close} centered>
                <MDBModalHeader toggle={this.modaldisallow_close}>รายละเอียดที่ไม่อนุมัติคำร้องขอ</MDBModalHeader>
                <MDBModalBody>
                    <div className="form-outline mt-2">
                        <label className="form-label" for="REASONS">รายละเอียดที่ไม่อนุมัติคำร้องขอ</label>
                        <input type="text" className="form-control" id="REASONS" name="REASONS" value={this.state.REASONS} onChange={this.handleChange} required />
                    </div>
                </MDBModalBody>
                <MDBModalFooter>
                    <button type="button" className="btn btn-primary btn-md" onClick={this.Update} value="0" >บันทึก</button>
                    <button type="button" className="btn btn-danger btn-md" onClick={this.modaldisallow_close}>ยกเลิก</button>
                </MDBModalFooter>
            </MDBModal>

        </>)
    }
}